import React, { Component } from "react";
import { Card } from "antd";
import "./tab/tab.css";
import {
  SearchOutlined,
  EnvironmentOutlined,
  DollarCircleOutlined,
} from "@ant-design/icons";
import LanguageSelector from "../../components/button/LanguageSelector";
import Tracking from "./tab/Tracking";
import CekTarif from "./tab/CekTarif";
import Cabang from "./tab/Cabang";

class PageTitleHome extends Component {
  constructor(props) {
    super(props);
    this.state = {
      lang: "En",
      activeTab: "0",
    };

    this.onChangeValue = this.onChangeValue.bind(this);
  }

  componentDidMount() {
    this.setState({ activeTab: "0" });
  }

  setActiveTab = (key) => {
    this.setState({ activeTab: key });
    console.log(key);
  };

  onChangeValue(event) {
    this.setState({
      lang: event.target.title,
    });
  }
  render() {
    const { activeTab } = this.state;
    console.log(this.state.activeTab);
    // Data tab
    const tabItems = [
      {
        key: "1",
        title: "Tracking",
        description: "Track Your Shipment Number",
        icon: <SearchOutlined style={{ fontSize: "24px", color: "#3F51B5" }} />,
        content: <Tracking />,
      },
      {
        key: "2",
        title: "Rate",
        description: "Estimate Shipment Rate",
        icon: (
          <DollarCircleOutlined
            style={{ fontSize: "24px", color: "#3F51B5" }}
          />
        ),
        content: <CekTarif />,
      },
      {
        key: "3",
        title: "Nearby Drop Point",
        description: "Drop your package to us",
        icon: (
          <EnvironmentOutlined style={{ fontSize: "24px", color: "#3F51B5" }} />
        ),
        content: <Cabang />,
      },
    ];

    return (
      <>
        {/* Section Header */}
        <section
          id="page-title"
          style={{
            backgroundImage: `url(${require("../../assets/img/placeholder/kargo.jpg")})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            position: "relative",
            padding: "60px 0",
            color: "#fff",
          }}
        >
          {/* Overlay */}
          <div
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              backgroundColor: "rgba(0, 0, 0, 0.6)",
            }}
          ></div>

          {/* Content */}
          <div
            className="wrapper"
            style={{
              position: "relative",
              zIndex: 2,
              textAlign: "center",
              marginTop: "80px",
            }}
          >
            <img
              style={{ marginTop: "50px" }}
              width="450"
              className={"logo-primary-light"}
              src={"assets/img/logo/logo-1-dark.svg"}
              alt="Logo"
            />
            <p
              style={{
                fontSize: "18px",
                marginTop: "20px",
                color: "#E0E0E0",
                maxWidth: "600px",
                marginLeft: "auto",
                marginRight: "auto",
                lineHeight: "1.5",
              }}
            >
              "We are your trusted partner in shipping and logistics, providing
              reliable solutions for the delivery of goods, documents, and
              cargo, both domestically and internationally."
            </p>

            {/* Language Selector */}
            <div
              style={{
                marginTop: "80px",
                marginBottom: "10px",
                display: "inline-block",
                padding: "10px 20px",
              }}
            >
              <p style={{ color: "#E0E0E0", marginBottom: "10px" }}>
                Download ILI Express Online Apps on Playstore
              </p>
              <a
                href="https://play.google.com"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  src={require("../../assets/img/logo/googleplay.png")}
                  alt="Google Play"
                  style={{ width: "190px", height: "auto" }}
                />
              </a>
            </div>
            <div
              style={{
                marginTop: "20px",
                display: "flex",
                justifyContent: "center",
                gap: "15px",
              }}
            >
              <nav className="languages">
                <ul className="nav" onClick={this.onChangeValue}>
                  <LanguageSelector
                    title="Id"
                    className={this.state.lang === "Id" ? "current-lang" : ""}
                  />
                  <LanguageSelector
                    title="En"
                    className={this.state.lang === "En" ? "current-lang" : ""}
                  />
                  <LanguageSelector
                    title="Cn"
                    className={this.state.lang === "Cn" ? "current-lang" : ""}
                  />
                </ul>
              </nav>
            </div>
          </div>
        </section>

        {/* Feature Section */}
        <div className="page-title-home-card">
          {/* Kontainer kartu */}
          <div className="tab-card-container">
            {tabItems.map((tab) => (
              <Card
                key={tab.key}
                className={`tab-card ${activeTab === tab.key ? "active" : ""}`}
                onClick={() => this.setActiveTab(tab.key)}
                hoverable
                style={{
                  textAlign: "center",
                  marginBottom: "50px",
                  borderRadius: "12px",
                  background: "linear-gradient(to right, #FDEB71, #F8D800)",
                  border: activeTab === tab.key ? "2px solid #3F51B5" : "none",
                  boxShadow:
                    activeTab === tab.key
                      ? "0 8px 20px rgba(0, 0, 0, 0.2)"
                      : "0 4px 10px rgba(0, 0, 0, 0.1)",
                  transition: "all 0.3s ease-in-out",
                }}
              >
                <div className="tab-icon">{tab.icon}</div>
                <h3 className="tab-title">{tab.title}</h3>
                <p className="tab-description">{tab.description}</p>
              </Card>
            ))}
          </div>

          {/* Konten kartu */}

          <div className="content-section">
            {tabItems.map((tab) => (
              <div
                key={tab.key}
                className={`tab-pane ${
                  activeTab === tab.key ? "tab-pane-active" : ""
                }`}
              >
                {tab.content}
              </div>
            ))}
          </div>
        </div>
      </>
    );
  }
}

export default PageTitleHome;
